import { type IContent } from "@kunduz/data-access-cms-api";
import React, { ReactElement } from "react";
import { ComponentRenderer } from "../componentRenderer/componentRenderer";
import styles from "./componentGroup.module.scss";

export const ComponentGroup = (props: Props): ReactElement => {
  return (
    <section
      style={{
        backgroundImage: `url(${props.data.bg_image})`,
        backgroundColor: props.data.bg_color,
      }}
      className={styles.container}
      id={props.data.anchor_tag}
    >
      <div className={styles.contentContainer}>
        <ComponentRenderer
          lang={"tr"}
          components={props.data.components.map((x, i) => ({
            component_type: x.component_type,
            data: [x.data],
            name: `comp_${i}`,
          }))}
        />
      </div>
    </section>
  );
};

interface Props {
  data: IContent.GroupedComponentData;
}
